"use client";

import { Suspense, use } from "react";
import { useLoader } from "@rangojs/router/client";
import { PriceLoader } from "../pages/shop/category.js";

function PriceValue({
  productId,
  fallbackPrice,
  fallbackCurrency,
}: {
  productId: string;
  fallbackPrice: number;
  fallbackCurrency: string;
}) {
  const { data } = useLoader(PriceLoader);
  const prices = use(data.prices);
  const userPrice = prices?.[productId];
  const price = userPrice?.price ?? fallbackPrice;
  const wasPrice = userPrice?.wasPrice;
  const currency = userPrice?.currency ?? fallbackCurrency;

  return wasPrice != null ? (
    <>
      <span className="text-slate-400 line-through">
        {currency} {wasPrice.toFixed(2)}
      </span>{" "}
      <span className="font-medium text-red-600">
        {currency} {price.toFixed(2)}
      </span>
    </>
  ) : (
    <>
      {currency} {price.toFixed(2)}
    </>
  );
}

export function ProductPrice({
  productId,
  price,
  currency = "GBP",
}: {
  productId: string;
  price: number;
  currency?: string;
}) {
  return (
    <p className="mt-1 text-sm text-slate-600">
      <Suspense
        fallback={
          <>
            {currency} {price.toFixed(2)}{" "}
            <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-slate-400" />
          </>
        }
      >
        <PriceValue productId={productId} fallbackPrice={price} fallbackCurrency={currency} />
      </Suspense>
    </p>
  );
}
